import Svg, { Path, Rect } from 'react-native-svg'
export const DownArrow = () => {
  return (
    <Svg id="down-arrow" width="16" height="16" viewBox="0 0 16 16">
      <Rect id="Rectangle_1948" data-name="Rectangle 1948" width="16" height="16" fill="#fff" opacity="0" />
      <Path
        id="Path_1896"
        data-name="Path 1896"
        d="M8.469,8.063v.023q0,.008-.016.008a.069.069,0,0,1-.008.031.069.069,0,0,0-.008.031l-.008.016a.069.069,0,0,0-.008.031.032.032,0,0,1-.008.023l-.008.008a.085.085,0,0,1-.031.039L8.328,8.3h0a.064.064,0,0,1-.023.039l-.039.039a.122.122,0,0,1-.031.023l-.016.008a.032.032,0,0,0-.023.008.032.032,0,0,1-.023.008.069.069,0,0,0-.031.008l-.016.008a.069.069,0,0,0-.031.008.069.069,0,0,1-.031.008.129.129,0,0,0-.039.008.173.173,0,0,1-.055.008H1.875a.5.5,0,1,1,0-1H6.766L.156.844A.453.453,0,0,1,0,.492.408.408,0,0,1,.156.156.388.388,0,0,1,.313.039.484.484,0,0,1,.5,0,.484.484,0,0,1,.688.039.388.388,0,0,1,.844.156L7.469,6.766V1.875a.5.5,0,1,1,1,0V8.063Z"
        transform="translate(8 2.012) rotate(45)"
        fill="#c94949"
        stroke="#c94949"
        strokeWidth="1"
      />
    </Svg>
  )
}
